import { __rest } from '../../_virtual/_tslib.esm.js';
import React__default from 'react';
import styledComponent from '../../node_modules/@mui/material/styles/styled.esm.js';
import Typography from '../../node_modules/@mui/material/Typography/Typography.esm.js';
import Box from '../../node_modules/@mui/material/Box/Box.esm.js';
import MuiLinearProgress from '../../node_modules/@mui/material/LinearProgress/LinearProgress.esm.js';

const StyledTypography = styledComponent(Typography)(({ theme, uppercase }) => ({
    fontSize: 12,
    marginBottom: theme.spacing(1),
    textTransform: uppercase ? 'uppercase' : 'initial'
}));
const StyledBox = styledComponent(Box, {
    shouldForwardProp: (prop) => prop !== 'withPercentage'
})(({ withPercentage }) => ({
    marginRight: withPercentage ? '16px' : '0',
    width: '100%'
}));
const LinearProgress = (_a) => {
    var { title, titleUppercase, withPercentage } = _a, rest = __rest(_a, ["title", "titleUppercase", "withPercentage"]);
    return (React__default.createElement(React__default.Fragment, null,
        !!title && React__default.createElement(StyledTypography, { uppercase: titleUppercase }, title),
        React__default.createElement(Box, { display: "flex", width: "100%", alignItems: "center" },
            React__default.createElement(StyledBox, { withPercentage: withPercentage },
                React__default.createElement(MuiLinearProgress, Object.assign({}, rest))),
            withPercentage && (React__default.createElement(Box, { minWidth: 35 },
                React__default.createElement(Typography, { variant: "body2", align: "right", color: "#5C6B88" }, `${rest.value !== undefined && (rest === null || rest === void 0 ? void 0 : rest.value) < 0.5 && (rest === null || rest === void 0 ? void 0 : rest.value) > 0 ? '< 1' : Math.round(rest.value || 0)} %`))))));
};
LinearProgress.defaultProps = {
    title: '',
    titleUppercase: false,
    withPercentage: false,
    classes: {}
};

export { LinearProgress as default };
